export enum AssessmentType {
    FULL_TEST = 'full_test',
    QUICK_TEST = 'quick_test',
}

export const LIMIT_FOR_PAGINATION = 12;
export const SIZE_PAGE_OPTIONS = [
    { value: 12, label: 12 },
    { value: 24, label: 24 },
    { value: 36, label: 36 },
];
